// FINANCE CLIENT
export const GET_STUDY_BUDGETS = 'GET_STUDY_BUDGETS';
export const ADD_STUDY_BUDGET = 'ADD_STUDY_BUDGET';
export const GET_BUDGET_SITES = 'GET_BUDGET_SITES';
export const ADD_BUDGET_SITE = 'ADD_BUDGET_SITE';
export const COPY_STUDY_BUDGET = 'COPY_STUDY_BUDGET';
export const UPDATE_STUDY_BUDGET = 'UPDATE_STUDY_BUDGET';

export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES';
export const SET_HOME_PAGE_DASHBOARDS_CONFIG = 'SET_HOME_PAGE_DASHBOARDS_CONFIG';
